<script lang="ts">
	import { cloudinaryUrl } from "#lib/shared/cloudinary.js";

	let {
		title = "Coming Soon",
		message = "This section is currently under construction. Please check back later for updates!",
		imageUrl = cloudinaryUrl("fergmar-com/coming-soon-bg", { width: 1920, quality: 30 })
	} = $props();
</script>

<div class="fixed inset-0 z-9999 h-screen w-screen">
	<img
		src={imageUrl}
		alt="Coming soon background"
		class="absolute inset-0 -z-10 size-full object-cover"
		width="1920"
		height="1080"
		loading="eager"
	/>
	<div
		class="mx-auto flex h-full max-w-4xl flex-col items-center justify-center px-6 py-24 text-center sm:py-32 lg:px-8"
	>
		<h1 class="mt-4 text-5xl font-semibold tracking-tight text-balance text-white sm:text-6xl">
			{title}
		</h1>
		<p class="mt-6 text-lg leading-8 font-medium text-pretty text-white/80 sm:text-xl">
			{message}
		</p>
		<div class="mt-10 flex justify-center">
			<a href="/" class="text-sm leading-7 font-semibold text-white hover:text-white/80">
				<span aria-hidden="true">&larr;</span> Back to home
			</a>
		</div>
	</div>
</div>
